export default "__VITE_ASSET__DlVMTyDe__"